<template>
  <v-card class="unit-list">
    <slot :mobilePortrait="mobilePortrait" name="header"></slot>
    <div class="card_body">
      <unit-list-filter/>
      <v-data-table
        :custom-sort="sortItems"
        :disable-pagination="true"
        :footer-props="{disablePagination: true, itemsPerPageText: $t('Rows_per_page')}"
        :header-props="{sortByText: $t('Sort_by')}"
        :headers="headers"
        :items="unitList"
        :mobile-breakpoint="240"
        :no-data-text="$t('filter_nomatch')"
        :sort-by.sync="pagination.sortBy"
        :sort-desc="pagination.descending"
        class="filter_table"
        hide-default-footer
        item-key="name"
        must-sort
      >
        <template v-slot:headers="props">
          <tr>
            <th
              :class="[
              'column sortable text-xs-left',
              pagination.descending ? 'desc' : 'asc',
              props.headers[0].value === pagination.sortBy ? 'active' : ''
            ]"
              @click="changeSort(props.headers[0].value)"
            >
              {{ $t(props.headers[0].text) }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th
              :class="[
              'column sortable text-xs-left',
               pagination.descending ? 'desc' : 'asc',
               props.headers[1].value === pagination.sortBy ? 'active' : ''
             ]"
              @click="changeSort(props.headers[1].value)"
            >
              {{ $t(props.headers[1].text) }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th
              :class="[
              'column sortable text-xs-left',
              pagination.descending ? 'desc' : 'asc',
              props.headers[2].value === pagination.sortBy ? 'active' : ''
            ]"
              @click="changeSort(props.headers[2].value)"
            >
              {{ $t(props.headers[2].text) }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th
              v-if="!mobilePortrait"
              :class="[
              'column sortable text-xs-left',
              pagination.descending ? 'desc' : 'asc',
              props.headers[3].value === pagination.sortBy ? 'active' : ''
            ]"
              @click="changeSort(props.headers[3].value)"
            >
              {{ $t(props.headers[3].text) }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th
              :class="[
              'column sortable text-xs-left',
              pagination.descending ? 'desc' : 'asc',
              props.headers[4].value === pagination.sortBy ? 'active' : ''
            ]"
              @click="changeSort(props.headers[4].value)"
            >
              {{ $t(props.headers[4].text) }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th
              :class="[
              'column sortable text-xs-left',
              pagination.descending ? 'desc' : 'asc',
              props.headers[5].value === pagination.sortBy ? 'active' : ''
            ]"
              @click="changeSort(props.headers[5].value)"
            >
              {{ $t(props.headers[5].text) }}
              <v-icon small>arrow_upward</v-icon>
            </th>
            <th
              :class="[
              'column sortable text-xs-left',
              pagination.descending ? 'desc' : 'asc',
              props.headers[6].value === pagination.sortBy ? 'active' : ''
            ]"
              @click="changeSort(props.headers[6].value)"
            >
              {{ $t(props.headers[6].text) }}
              <v-icon small>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item }">
          <tr class="clickable" @click="openUnit(item)">
            <td>{{ item.name }}</td>
            <td>
              {{
                item.status.display_attributes && !isPriceAttributeHidden(item) ? item.formattedAttributes.price : ''
              }}
            </td>
            <td>{{ item.status.display_attributes ? item.attributes.rooms : '' }}</td>
            <td class="hidden-xs-only">
              {{ item.status.display_attributes ? item.formattedAttributes.size_gross : '' }}
            </td>
            <td v-if="isAny_floor_ext_int_num" class="hidden-xs-only">
              {{ item.status.display_attributes ? item.attributes.floor_ext_int_num : '' }}
            </td>
            <td v-if="isAny_fee_monthly"  class="hidden-xs-only">
              {{
                item.status.display_attributes && !isPriceAttributeHidden(item)
                  ? item.formattedAttributes.fee_monthly
                  : ''
              }}
            </td>
            <td>
              <span
                v-if="!!getUnitColorHex(item)"
                :style="{'background-color': getUnitColorHex(item)}"
                class="badge"
              >
                {{ $t(item.status.name) }}
              </span>
              <span
                v-else
                :class="['badge', item.status.color_class || item.status.color]"
              >
                {{ $t(item.status.name) }}
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { sortItems } from 'vuetify/lib/util/helpers';
import UnitListFilter from '@/components/UnitListFilter.vue';

const SORT_BY_STATUS = 'status.position';

export default {
  components: { UnitListFilter },
  data() {
    return {
      pagination: {
        sortBy: SORT_BY_STATUS,
        descending: false,
      },
    };
  },
  computed: {
    ...mapGetters('project', ['statuses', 'languageDefault']),
    ...mapGetters('filters', ['unitList']),
    ...mapGetters('service', ['mobilePortrait']),
    isAny_floor_ext_int_num() {
      return this.unitList.some((item) => item.attributes.floor_ext_int_num)
    },
    isAny_fee_monthly() {
      return this.unitList.some((item) => item.formattedAttributes.fee_monthly)
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    headers() {
      const result = [
        { text: this.$t('Unit'), align: 'left', value: 'name' },
        { text: this.$t('Price'), value: 'attributes.price' },
        { text: this.$t('Rooms'), value: 'attributes.rooms' },

      ];

      if (!this.mobilePortrait) {
        result.push(...[
          { text: this.$t('Size'), value: 'attributes.size_gross_num', class:'hidden-xs-only' },
        ]);
        if (this.isAny_floor_ext_int_num) {
          result.push(
            { text: this.$t('Floor'), value: 'attributes.floor_ext_int_num', class:'hidden-xs-only' },
          )
        }
        if (this.isAny_fee_monthly) {
          result.push(
            { text: this.$t('Fee'), value: 'attributes.fee_monthly', class:'hidden-xs-only' },
          )
        }
      }
      result.push({ text: this.$t('Status'), value: SORT_BY_STATUS });

      return result;
    },
  },
  methods: {
    isPriceAttributeHidden(unit) {
      const status = this.statuses.find(status => status.status_id === unit.status.status_id);

      return !status.display_price;
    },
    getUnitColorHex(unit) {
      const overlayStatus = this.statuses.find(status => status.status_id === unit.status.status_id);

      return overlayStatus ? overlayStatus.color : null;
    },
    openUnit(normalizedUnit) {
      const unitStatus = this.statuses.find(status => status.status_id === normalizedUnit.status.status_id);

      if (!unitStatus.accessible) {
        return false;
      }

      const { unit } = normalizedUnit;

      if (unitStatus.exturl && unit.exturl) {
        window.open(unit.exturl, '_blank');
      } else {
        this.$router.push({
          name: 'order.unit.view',
          params: {
            order: this.$route.params.order,
            unitId: normalizedUnit.unit_id,
          },
        });
      }

      return true;
    },
    sortItems(items, sortBy, sortDesc, locale, customSorters) {
      const [extendedSortBy, extendedSortDesc] = sortBy[0] !== 'name'
        ? [sortBy.concat('name'), sortDesc.concat(sortDesc[0])]
        : [sortBy, sortDesc];
      const advCustomSorters = Object.assign(customSorters, {
        name: (a, b) => a.toString()
          .localeCompare(b.toString(), undefined, { numeric: true }),
      });

      return sortItems(items, extendedSortBy, extendedSortDesc, locale, advCustomSorters);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .filters-panel {
  padding-top: 20px;
}
</style>
<style lang="scss">
.unit-list {
  max-width: 960px;
  margin: auto;

  .filter_table {
    overflow: auto;

    .v-data-table-header {
      .asc .v-data-table-header__icon:before {
        margin: -3px 0 0 3px;
      }

      .desc .v-data-table-header__icon:before {
        margin: 1px 2px 0 0;
      }
    }

    @supports (padding-bottom: env(safe-area-inset-bottom)) {
      padding-bottom: env(safe-area-inset-bottom) !important;
    }

    th {
      font-size: 0.81em;
      padding-top: 24px;
    }

    th,
    td {
      &:first-of-type {
        @supports (padding-left: env(safe-area-inset-left)) {
          padding-left: calc(env(safe-area-inset-left) + 24px) !important;
        }
      }

      &:last-of-type {
        @supports (padding-right: env(safe-area-inset-right)) {
          padding-right: calc(env(safe-area-inset-right) + 24px) !important;
        }
      }
    }
  }

  .badge {
    color: #fff;
    padding: 1px 6px;
    border-radius: 2px;
    background: #ccc;
    display: inline-block;
    font-size: 0.75em;

    &.color_status_a {
      background-color: rgba(var(--color-status-a), 1.0);
    }

    &.color_status_b {
      background-color: rgba(var(--color-status-b), 1.0);
    }

    &.color_status_c {
      background-color: rgba(var(--color-status-c), 1.0);
    }

    &.color_status_d {
      background-color: rgba(var(--color-status-d), 1.0);
    }
  }
}
</style>
